import { Helmet } from "react-helmet-async"
import { useParams, useSearchParams } from "../../../router-utils"
import { CancellationPolicyItemDetails } from "../../../CancellationPolicy"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"

export default function CancellationPolicyItemPage() {
	const { cancellationPolicyId } = useParams(
		"/cancellation-policy/:cancellationPolicyId"
	)
	// the list page carries these over when linking here
	const [query] = useSearchParams()
	const policyName = query.get("name") || "Cancellation Policy Details"
	const isDisabled = query.get("is_deleted") === "true"
	const isDefault = query.get("is_default") === "true"
	const versionId = Number(query.get("version_id")) || undefined
	const version = Number(query.get("version")) || undefined

	return (
		<>
			<Helmet>
				<title>{policyName}</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<CancellationPolicyItemDetails
					detailId={Number(cancellationPolicyId)}
					name={policyName}
					isDisabled={isDisabled}
					isDefault={isDefault}
					versionId={versionId}
					version={version}
				/>
			</ForbidUnlessAuthorized>
		</>
	)
}
